export default "__VITE_ASSET__ClASDHF0__"